import type { Point } from "@lib/zod/deliverySchema";

function normalizeLng(lng: number): number {
    return ((lng + 180) % 360 + 360) % 360 - 180;
}

// Shift a longitude so it is within [-180, 180) of a reference longitude,
// keeping relative positions correct across the antimeridian.
function shiftLng(lng: number, reference: number): number {
    let normalized = normalizeLng(lng);
    const ref = normalizeLng(reference);
    if (normalized - ref > 180) normalized -= 360;
    if (normalized - ref < -180) normalized += 360;
    return normalized;
}

export function isInsidePolygon(point: Point, path: Point[]) {
    // ray-casting algorithm
    const x = point.lat!;
    const y = normalizeLng(point.lng!);
    // Normalize all vertex longitudes relative to the point to handle antimeridian crossings
    const pathArray = path.map((p) => [p.lat, shiftLng(p.lng!, y)]);
    let inside = false;
    for (let i = 0, j = path.length - 1; i < path.length; j = i++) {
        const xi = pathArray[i]![0]!;
        const yi = pathArray[i]![1]!;
        const xj = pathArray[j]![0]!;
        const yj = pathArray[j]![1]!;
        const intersect = ((yi > y) != (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
    }
    return inside;
}